<script>
import { Bar, Line } from 'vue-chartjs'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'

let default_option = {
  responsive: true,
  maintainAspectRatio: true,
  tooltips: {
    enabled: false,
    custom: CustomTooltips,
    intersect: true,
    mode: 'index',
    position: 'nearest',
    callbacks: {
      labelColor: function (tooltipItem, chart) {
        return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].backgroundColor }
      }
    }
  },
  scales: {
    yAxes: [{
      scaleLabel: {
        display: true,
        labelString: 'KWh'
      }
    }],
    xAxes: [{
      scaleLabel: {
        display: true,
        labelString: '時間'
      }
    }]
  } 
};

export default {
  components: {
    CustomTooltips
  },
  props: ['data', 'options'],
  extends: Line,
  mounted () {
    this.renderChart(this.data, this.options || default_option );
  },
  watch: {
    data: function() {
      this.renderChart(this.data, this.options || default_option );
    }
  }
}
</script>
